import AuthService from "../login/auth.service";
import { tarjetas } from "../../components/generico/utils/UrlAPI";
import axios from "axios";

class SuscripcionExtractoService {
  async obtenerTarjetasSocio() {

    // var usuario = AuthService.getSocio();
    // var persona = usuario.idPersona;

    var config = {
      method: "get",
      url: tarjetas + "extractos/suscripcionExtracto",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(config);
  }

  async suscribirExtracto(correo, ListaTarjetas) {
    var data = JSON.stringify({
      tarjetas: ListaTarjetas,
      correo: correo,
      canal: "WEB",

    });

    var config = {
      method: "post",
      url: tarjetas + "extractos/suscripcionExtracto",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  async cancelarSuscripcionExtracto(ListaTarjetas) {
    var data = JSON.stringify({
      tarjetas: ListaTarjetas,
      canal: "WEB",
    });

    var config = {
      method: "post",
      url: tarjetas + "extractos/cancelarSuscripcionExtracto",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

}
export default new SuscripcionExtractoService();
